import i18n, { setStoredLanguage, type SupportedLanguage } from '@store/i18n';
import type { TFunction } from 'i18next';
import { useTranslation } from 'react-i18next';

type UseAppTranslationReturn = {
  t: TFunction;
  language: SupportedLanguage;
  setLanguage: (lng: SupportedLanguage) => Promise<void>;
};

export const useAppTranslation = (): UseAppTranslationReturn => {
  const { t } = useTranslation();
  const language = i18n.language as SupportedLanguage;
  const setLanguage = async (lng: SupportedLanguage): Promise<void> => {
    await setStoredLanguage(lng);
    await i18n.changeLanguage(lng);
  };
  return { t, language, setLanguage };
};
